import React, { useEffect, useState } from 'react'
import { useTranslate } from '../../components/TranslationText';
import { getHandlerShows } from './api/handlerShowApis';
import SearchBox from '../../components/SearchBox';
import HandlerShowItem from './HandlerShowItem';

export default function HandlerShowList({toast}) {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const [shows, setshows] = useState([]);
    const { translate } = useTranslate();
    const [searchShows, setSearchShows] = useState("");

    useEffect(() => {
        getHandlerShows().then((res) => {

            setshows(res ?? []);
        });
    }, [])


    const diesplayedShow = shows
        .filter((item) => {
            if (searchShows === "") {
                return item;
            } else if (searchShows !== "") {
                return item?.nameEn
                    .toLowerCase()
                    .includes(searchShows.toLowerCase());
            }
        });

    return (
        <div className="col-lg-9 col-md-9 col-sm-12  rtl">
            <div className="row rtl mb-main" >
                <div className="col-sm-6 col-12">
                    <SearchBox
                        isFullWidth
                        onChange={(e) => {
                            setSearchShows(e.target.value);
                        }}
                        placeholder={translate(
                            "web.search",
                            "Search"
                        )}
                    />
                </div>
            </div>
            <div className="row">
                {!!diesplayedShow && diesplayedShow.length > 0
                    ? diesplayedShow.map((item, i) => (
                        <HandlerShowItem i={i} item={item} translate={translate} toast={toast} currentLanguage={currentLanguage} />
                    )) : ''}
            </div>
        </div>
    )
}
